import { useState } from 'react'

import {
  Alert,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material'

interface SendToXeroDialogProps {
  open: boolean
  onClose: () => void
  queuedIds: Array<string>
}

const MAX_VISIBLE = 10

const SendToXeroDialog = ({ open, onClose, queuedIds }: SendToXeroDialogProps) => {
  const [expanded, setExpanded] = useState(false)
  const visible = expanded ? queuedIds : queuedIds.slice(0, MAX_VISIBLE)

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Send to Xero</DialogTitle>
      <DialogContent dividers>
        <Alert severity='info'>
          {queuedIds.length} batch{queuedIds.length !== 1 ? 'es are' : ' is'} being sent to Xero.
          You&apos;ll see the updated status in the list shortly.
        </Alert>
        <Typography variant='body2' sx={{ mt: 1.5 }}>
          Batch ID{queuedIds.length !== 1 ? 's' : ''}:
        </Typography>
        <Stack direction='row' flexWrap='wrap' gap={0.5} sx={{ mt: 0.5 }}>
          {visible.map((id) => (
            <Chip key={id} label={id} size='small' />
          ))}
          {!expanded && queuedIds.length > MAX_VISIBLE && (
            <Chip
              label={`+${queuedIds.length - MAX_VISIBLE} more`}
              size='small'
              variant='outlined'
              onClick={() => setExpanded(true)}
              clickable
            />
          )}
        </Stack>
        <Typography variant='body2' sx={{ mt: 1, color: 'text.secondary' }}>
          These batches cannot be re-selected while processing.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}

export default SendToXeroDialog
